import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from './Modal';
import { resetModal } from '../actions/modalsActions';
import i18n from '../utils/i18n';
import ApiClient from '../utils/apiClient';

class EmergencyContactModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emergencyContactData: '',
      errors: false
    };

    this.getEmergencyContactData = this.getEmergencyContactData.bind(this);
  }

  componentDidMount() {
    this.getEmergencyContactData();
  }

  getEmergencyContactData() {
    const { userId, accessToken } = this.props.modalData;
    ApiClient.get(`/api/v1/emergency-contact/${userId}/${accessToken}`)
      .then(response => {
        this.setState({ emergencyContactData: response.data });
      })
      .catch(() => {
        this.setState({ errors: true });
      });
  }

  render() {
    const { emergencyContactData, errors } = this.state;
    return (
      <Modal
        isOpen={ true }
        onRequestClose={ this.props.resetModal }
        closeButtonText={ i18n.t('modals.emergency_contact.CANCEL_BUTTON') }
        showActionButton={ false }
      >
        <div className="modal-container">
          <h1 className="modal-header">
            {i18n.t('modals.emergency_contact.TITLE')}
          </h1>
          <div>
            {!errors && (
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td className="font-medium" style={ { width: '60%' } }>
                      {i18n.t(
                        'modals.emergency_contact.EMERGENCY_CONTACT_NAME'
                      )}
                    </td>
                    <td>{emergencyContactData.emergency_name}</td>
                  </tr>
                  <tr>
                    <td className="font-medium">
                      {i18n.t(
                        'modals.emergency_contact.EMERGENCY_CONTACT_PHONE_NUMBER'
                      )}
                    </td>
                    <td>{emergencyContactData.emergency_phone_number}</td>
                  </tr>
                  <tr>
                    <td className="font-medium">
                      {i18n.t(
                        'modals.emergency_contact.EMERGENCY_CONTACT_RELATIONSHIP'
                      )}
                    </td>
                    <td>{emergencyContactData.emergency_relationship}</td>
                  </tr>
                  <tr>
                    <td className="font-medium">
                      {i18n.t(
                        'modals.emergency_contact.EMERGENCY_CONTACT_EXISTING_CONDITIONS'
                      )}
                    </td>
                    <td>
                      {emergencyContactData.emergency_existing_conditions}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
            {errors && (
              <div className="text-danger">
                {i18n.t('modals.emergency_contact.GETTING_ERROR')}
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

EmergencyContactModal.propTypes = {
  modalData: PropTypes.shape({
    userId: PropTypes.number.isRequired,
    accessToken: PropTypes.string.isRequired
  }).isRequired, 
  resetModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  modalData: state.modals.modalData
});

const mapDispatchToProps = dispatch => ({
  resetModal: () => dispatch(resetModal()),
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(
  EmergencyContactModal
);



// WEBPACK FOOTER //
// ./src/modals/EmergencyContactModal.js